// The same limits the server checks (server/src/domain/freeText.ts and goalFields.ts)
export const MAX_LONG_TEXT = 10_000;
export const MAX_SHORT_TEXT = 200;
export const MAX_NOTES = 4000;
export const MAX_INVITATION_TEXT = 4000;
export const MAX_SURVEY_NAME = 200;
export const MAX_REFLECTIONS = 6000;
export const MAX_COMMENT_CONTENT = 6000;
export const MAX_GOAL_NAME = 80;
export const MAX_GOAL_TEXT = 6000;
